const COLUMNS = [
  { title: "Supports", items: ["Support Coordination", "Personal Care & Daily Living", "Community Outings", "Household Help"] },
  { title: "Audiences", items: ["Support Coordinators", "Participants", "Families & Carers"] },
  { title: "Coverage", items: ["Greater Adelaide", "Adelaide Hills", "Fleurieu & Barossa", "Regional South Australia"] },
];

export default function Footer() {
  return (
    <footer className="bg-[#222E33] text-[#FAF8F5] py-16 px-5 sm:px-8" data-testid="site-footer">
      <div className="max-w-6xl mx-auto space-y-12">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 pb-8 border-b border-[#36444B]">
          <div>
            <div className="flex items-center gap-3">
              <img src="/logo.png" alt="Beneficence Care logo" className="h-12 w-12 rounded-full" />
              <span className="text-2xl font-display font-semibold tracking-tight text-white">Beneficence Care</span>
            </div>
            <p className="text-xs text-[#A1B0B7] mt-1">Registered NDIS Provider · Statewide South Australia</p>
          </div>
          <div className="flex items-center gap-4">
            <a href="tel:+61450552557" data-testid="footer-call-button" className="px-5 py-2.5 rounded-full text-xs font-semibold border border-[#4A5A62] text-[#DDE6EA] hover:bg-[#2C3A41] transition-colors">
              Call 0450 552 557
            </a>
            <a href="#contact" data-testid="footer-book-button" className="px-5 py-2.5 rounded-full text-xs font-semibold bg-[#FAF8F5] text-[#222E33] hover:bg-[#EAE2D5] transition-colors">
              Book Appointment
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-xs text-[#B2C1C8]">
          {COLUMNS.map((col) => (
            <div key={col.title} className="space-y-3">
              <div className="font-semibold text-white uppercase tracking-wider text-[11px]">{col.title}</div>
              <div className="space-y-2">
                {col.items.map((item) => (
                  <div key={item}>{item}</div>
                ))}
              </div>
            </div>
          ))}
          <div className="space-y-3">
            <div className="font-semibold text-white uppercase tracking-wider text-[11px]">Direct Actions</div>
            <div className="space-y-2">
              <a href="#contact" data-testid="footer-booking-link" className="block hover:text-white transition-colors">Book Online Calendar</a>
              <a href="#contact" data-testid="footer-enquiry-link" className="block hover:text-white transition-colors">Send Form Enquiry</a>
              <a href="mailto:ndis@beneficencecare.com" data-testid="footer-email-link" className="block hover:text-white transition-colors">ndis@beneficencecare.com</a>
              <a href="#services" data-testid="footer-services-link" className="block hover:text-white transition-colors">View All Services</a>
              <a href="/admin" data-testid="footer-owner-login-link" className="block hover:text-white transition-colors">Owner Login</a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-[#36444B] flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-[#8A9BA2]">
          <div>Beneficence Care · NDIS Registered Disability Support</div>
          <div>Dedicated to respectful, reliable care across South Australia</div>
        </div>
      </div>
    </footer>
  );
}
